import { ReactElement } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import {
  Typography,
  Box,
  Button,
  IconButton,
  DialogTitle,
  DialogContentText,
  DialogActions,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'next-i18next';

import { DialogContentStyle, useCssClasses } from './style';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

type Props = {
  dialog: { opened: boolean; open: () => void; close: () => void; render: (children: ReactElement) => JSX.Element };
  onConfirm: () => void;
  onCancel: () => void;
};

const ConfirmationUseOneLicenseModal = ({ dialog, onConfirm, onCancel }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const classes = useCssClasses();

  const onClickCancel = () => {
    onCancel();
    dialog.close();
  };

  const onClickConfirm = () => {
    dialog.close();
    onConfirm();
  };

  return (
    <>
      <DialogTitle>
        <Box sx={{ position: 'absolute', top: 8, right: 8 }}>
          <IconButton onClick={() => onClickCancel()} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Box display="flex" alignItems="center" flexDirection="column" rowGap="1" paddingX={5}>
          <FontAwesomeIcon
            style={{ fontSize: '50px' }}
            color={theme.palette.grey[500]}
            icon="fa-light fa-circle-exclamation"
          />
          <Typography color="primary.main" variant="h3" align="center" sx={{ mt: 2 }}>
            {t('cpd_enrollment.license_information.confirmation_select_one_licences.title')}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContentStyle>
        <DialogContentText>
          <Typography sx={{ fontFamily: 'Lanna' }} align="center" variant="body2_deprecated">
            {t('cpd_enrollment.license_information.confirmation_select_one_licences.subtitle')}
          </Typography>
        </DialogContentText>
      </DialogContentStyle>
      <DialogActions sx={{ justifyContent: 'space-between', pr: '80px', pl: '80px' }}>
        <Button variant="outlined" color="primary" onClick={() => onClickCancel()} className={classes.button}>
          {t('cancel')}
        </Button>
        <Button variant="contained" color="primary" onClick={() => onClickConfirm()} className={classes.button}>
          {t('confirm')}
        </Button>
      </DialogActions>
    </>
  );
};

export default ConfirmationUseOneLicenseModal;
